module.exports = __webpack_public_path__ + "img/c5e3b42.jpg";